import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { MapLayout } from '.';
import { useMapPreviewUrl } from './hooks';
import { EMapTypes } from '../../../constants/map';
import { selectVillage } from '../../../selectors/village';
import { IState } from '../../../store';
import { setMapType } from '../../../store/map';

export const MapLayoutContainer: React.FC = () => {
  const dispatch = useDispatch();

  const { mapType, yandexApiKeySatellite } = useSelector((state: IState) => state.map);
  const { coordinates, fullAddress, roadInfoList, stationInfoList, regionId, isFat } = useSelector(selectVillage);
  const countrysideRoadRegions = useSelector((state: IState) => state.countrysideRoadRegions);
  const countrysideStationRegions = useSelector((state: IState) => state.countrysideStationRegions);

  const handleSetMapType = (mapType: EMapTypes) => {
    dispatch(setMapType(mapType));
  };

  const mapPreviewUrl = useMapPreviewUrl();

  return (
    <MapLayout
      coordinates={coordinates}
      fullAddress={fullAddress || /* istanbul ignore next */ ''}
      regionId={regionId}
      roadInfo={
        (roadInfoList &&
          regionId &&
          countrysideRoadRegions.includes(regionId) &&
          /* istanbul ignore next */ roadInfoList[0]) ||
        undefined
      }
      stationInfo={
        (stationInfoList &&
          regionId &&
          countrysideStationRegions.includes(regionId) &&
          /* istanbul ignore next */ stationInfoList[0]) ||
        undefined
      }
      mapType={mapType}
      yandexApiKeySatellite={yandexApiKeySatellite}
      isFat={isFat}
      setMapType={handleSetMapType}
      mapPreviewUrl={mapPreviewUrl}
    />
  );
};
